import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContainerFormComponent } from "./container-form/container-form.component";
import { ContainerListComponent } from "./container-list/container-list.component";


const routes:Routes=[
    {
      path:'',
      data:{
        title:'Container',
      },
      component:ContainerListComponent
    },
    {
      path:'add',
      data:{
        title:'New Container',
      },
      component:ContainerFormComponent
    },
    {
      path:'edit/:id',
      data:{
        title:'Edit Container'
      },
      component:ContainerFormComponent
    }
  ]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class ContainerRoutingModule{

}